import React from 'react';
export function TomosPrimaria() {
  return <section className="py-16 px-6 bg-white" data-id="element-227">
      <div className="max-w-4xl mx-auto" data-id="element-228">
        <div className="text-center mb-10" data-id="element-229">
          <p className="text-blue-600 font-semibold uppercase tracking-widest text-sm mb-2" data-id="element-230">
            Lo que recibís
          </p>
          <h2 className="text-3xl font-extrabold text-gray-900" data-id="element-231">
            PRIMARIA — 6 TOMOS
          </h2>
          <p className="text-gray-500 mt-2" data-id="element-232">
            Para docentes de inglés de 1° a 6° grado
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-233">
          {[{
          num: '1',
          title: 'Tomo 1 — 1° Primaria',
          sub: 'First Steps in English',
          desc: 'Saludos, colores, números 1-10, objetos del aula y comandos básicos.',
          level: 'Pre-A1'
        }, {
          num: '2',
          title: 'Tomo 2 — 2° Primaria',
          sub: 'My World in English',
          desc: "Familia, casa, rutina, mascotas, emociones, CAN/CAN'T y preposiciones.",
          level: 'Pre-A1+'
        }, {
          num: '3',
          title: 'Tomo 3 — 3° Primaria',
          sub: 'Action & Fun!',
          desc: 'Verb TO BE, Present Simple, clima, ropa, comida, deportes y la hora.',
          level: 'A1'
        }, {
          num: '4',
          title: 'Tomo 4 — 4° Primaria',
          sub: "Explorer's Guide",
          desc: 'Present Continuous, comparativos, Past Simple y verbos irregulares.',
          level: 'A1'
        }, {
          num: '5',
          title: 'Tomo 5 — 5° Primaria',
          sub: 'Daily Life Stories',
          desc: 'Past Simple narrativo, GOING TO, WILL, Present Perfect intro y modales.',
          level: 'A1+'
        }, {
          num: '6',
          title: 'Tomo 6 — 6° Primaria',
          sub: 'Ready for the Leap',
          desc: 'Present Perfect avanzado, Passive Voice, Conditional 1 y 2, escritura PEEL.',
          level: 'A2'
        }].map(t => <div key={t.num} className="border border-gray-200 rounded-2xl p-5 flex gap-4 hover:shadow-md transition" data-id="element-234">
              <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-sm shrink-0" data-id="element-235">
                {t.num}
              </div>
              <div data-id="element-236">
                <p className="font-bold text-gray-900 text-sm" data-id="element-237">{t.title}</p>
                <p className="text-blue-600 text-xs font-semibold mb-1" data-id="element-238">
                  {t.sub}
                </p>
                <p className="text-gray-500 text-xs" data-id="element-239">{t.desc}</p>
                <span className="inline-block mt-2 bg-blue-50 text-blue-700 text-xs font-semibold px-2 py-0.5 rounded-full" data-id="element-240">
                  Nivel {t.level}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}